/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Sign16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            d="M15.5 15a.5.5 0 110 1H.5a.5.5 0 110-1h15zM5.5 0c1.426 0 2.38 1.961 2.49 4.088.007.137.01.774.01.912 0 2.098-.906 3.915-2.43 5.333l-.185.166.017.027c.549.855 1.224 1.406 1.96 1.468L7.5 12c.556 0 1.022-.47 1.568-1.508l.173-.345.37-.765.142-.278.128-.23C10.209 8.31 10.53 8 11 8c.638 0 .902.315 1.217 1.377l.102.361.267 1.033.137.482.079.252.097.278.048.122.034.071c.009.016.015.024.018.024.458 0 1.188-.584 2.1-1.8a.5.5 0 01.8.6C14.812 12.251 13.876 13 13 13c-.638 0-.903-.315-1.218-1.377l-.102-.361-.267-1.033-.137-.482-.078-.252-.097-.278-.049-.122-.034-.071C11.01 9.008 11.003 9 11 9l-.101.137-.097.145-.057.095-.111.2-.061.119-.5 1.028C9.316 12.234 8.614 13 7.5 13c-1.123 0-2.088-.676-2.833-1.755l-.078-.116-.05.038c-1.032.727-2.254 1.31-3.61 1.727l-.292.087a.5.5 0 01-.274-.962c1.376-.393 2.603-.964 3.615-1.683l.116-.086-.066-.138c-.631-1.374-.998-3.097-1.026-4.85L3 4.998c0-.143.004-.785.01-.924C3.114 1.73 4.02 0 5.5 0zm0 1c-.773 0-1.423 1.286-1.494 3.187-.002.078-.004.437-.005.657v.158c-.006 1.605.31 3.19.84 4.444l.06.137.077-.072C6.194 8.34 6.928 6.89 6.995 5.248L7 5v-.357l-.003-.357C6.94 2.58 6.213 1 5.5 1zM11 5a1 1 0 110 2 1 1 0 010-2z"
        />
    </AccessibleSVG>
);

export default Sign16;
